export default __webpack_public_path__ + "static/media/illustration-financial-freedom.831f93a5.svg";